import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Subscriptions from './pages/Subscriptions';
import Subscribe from './pages/Subscribe';
import Checkout from './pages/Checkout';
import Login from './pages/Login';
import Register from './pages/Register';
import Account from './pages/Account';
import CreateTestCustomer from './pages/CreateTestCustomer';
import Cart from './pages/Cart';
import Receipt from './pages/Receipt';
import About from './pages/About';
import Kits from './pages/Kits';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import AdminLogin from './pages/AdminLogin';
import AdminEmails from './pages/AdminEmails';

function useCurrentPageName() {
  const location = useLocation();
  const path = location.pathname.toLowerCase();
  if (path === '/' || path.startsWith('/home')) return 'Home';
  if (path.startsWith('/products')) return 'Shop';
  if (path.startsWith('/subscriptions') || path.startsWith('/subscribe')) return 'Subscriptions';
  if (path.startsWith('/events')) return 'Events';
  if (path.startsWith('/blog')) return 'Blog';
  if (path.startsWith('/about')) return 'About';
  if (path.startsWith('/kits')) return 'Kits';
  if (path.startsWith('/cart')) return 'Cart';
  return '';
}

function RoutedLayout() {
  const current = useCurrentPageName();
  const location = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [location.pathname]);
  return (
    <Layout currentPageName={current}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:id" element={<ProductDetail />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/receipt" element={<Receipt />} />
        <Route path="/about" element={<About />} />
        <Route path="/kits" element={<Kits />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-post" element={<BlogPost />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/account" element={<Account />} />
        <Route path="/create-test-customer" element={<CreateTestCustomer />} />

				<Route path="/admin" element={<Navigate to="/admin/emails" replace />} />
				<Route path="/admin/login" element={<AdminLogin />} />
				<Route path="/admin/emails" element={<AdminEmails />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <CartProvider>
      <AuthProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <RoutedLayout />
          </BrowserRouter>
        </AdminAuthProvider>
      </AuthProvider>
    </CartProvider>
  );
}

export default App;
